module.exports = __webpack_public_path__ + "static/media/order-header-bg2.0fffecaf.png";